import React, { useEffect } from "react";
import { MdArrowForwardIos } from "react-icons/md";
import Card from "./comsponent/Card";
import flower from "../../Asset/recent/flower.png";


const RecentPurchase = ({ datalist }) => {


  return (
    <div className="w-full flex flex-col bg-Background3" >
      <div className="py-7 md:px-12 px-4">
        {/* Header Section */}
        <div className="flex justify-between">
          <div className="flex flex-col">
            <span className="text-textColor text-lg md:text-3xl font-bold title">
              Recently Purchased
            </span>
            <span className="text-textColor text-base md:text-xl">
              People are buying frequently
            </span>
          </div>
        </div>

        {/* Mobile Slider View */}
      <div className="block md:hidden mt-5 overflow-x-auto">
          <div className="flex gap-4 w-max px-1 scrollbar-hide">
            {datalist?.map((item, index) => (
              <div key={index} className="w-[260px] flex-shrink-0">
                <Card item={item} index={index} />
              </div>
            ))}
          </div>
        </div>

        {/* Desktop Grid View */}
        <div className="hidden  md:grid mt-5 grid-cols-1 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5 gap-6 md:gap-8 lg:gap-4">
          {datalist?.map((item, index) => (
            <Card item={item} index={index} key={index} />
          ))}
        </div>
      </div>

      {/* Bottom Flower Image */}
      <div className="w-full mt-5">
        <img src={flower} className="w-full object-cover" alt="flower" />
      </div>
    </div>
  );
};

export default RecentPurchase;